var map = {
	"./MRC_IEU.png": "9ed4",
	"./PubMed.png": "06fa6",
	"./cruk_logo.jpg": "fb4a",
	"./efo-logo.gif": "b95d",
	"./gsk_logo.jpg": "aabd",
	"./igd-neg.svg": "4416",
	"./logo-biogen.jpg": "2ff4",
	"./open-gwas-logo.png": "b6ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d767";